<div [formGroup]="formGroup">
  <div>
    <mat-form-field appearance="fill">
      <mat-label>{{ countryTitle() }}</mat-label>
      <!-- TODO: Populate this from countries-list, use alpha2 codes? -->
      <select matNativeControl formControlName="country" required>
        <option value=""></option>
        <optgroup label="Europe">
          <option value="Albania">Albania</option>
          <option value="Andorra">Andorra</option>
          <option value="Austria">Austria</option>
          <option value="Belarus">Belarus</option>
          <option value="Belgium">Belgium</option>
          <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
          <option value="Bulgaria">Bulgaria</option>
          <option value="Croatia">Croatia</option>
          <option value="Cyprus">Cyprus</option>
          <option value="Czech Republic">Czech Republic</option>
          <option value="Denmark">Denmark</option>
          <option value="Estonia">Estonia</option>
          <option value="Faroe Islands">Faroe Islands</option>
          <option value="Finland">Finland</option>
          <option value="France">France</option>
          <option value="Germany">Germany</option>
          <option value="Gibraltar">Gibraltar</option>
          <option value="Greece">Greece</option>
          <option value="Guernsey">Guernsey</option>
          <option value="Hungary">Hungary</option>
          <option value="Iceland">Iceland</option>
          <option value="Ireland">Ireland</option>
          <option value="Italy">Italy</option>
          <option value="Jersey">Jersey</option>
          <option value="Latvia">Latvia</option>
          <option value="Liechtenstein">Liechtenstein</option>
          <option value="Lithuania">Lithuania</option>
          <option value="Luxembourg">Luxembourg</option>
          <option value="Macedonia">Macedonia</option>
          <option value="Malta">Malta</option>
          <option value="Moldova">Moldova</option>
          <option value="Monaco">Monaco</option>
          <option value="Montenegro">Montenegro</option>
          <option value="Netherlands">Netherlands</option>
          <option value="Norway">Norway</option>
          <option value="Poland">Poland</option>
          <option value="Portugal">Portugal</option>
          <option value="Romania">Romania</option>
          <option value="Russia">Russia</option>
          <option value="San Marino">San Marino</option>
          <option value="Serbia">Serbia</option>
          <option value="Serbia and Montenegro">Serbia and Montenegro</option>
          <option value="Slovakia">Slovakia</option>
          <option value="Slovenia">Slovenia</option>
          <option value="Spain">Spain</option>
          <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
          <option value="Sweden">Sweden</option>
          <option value="Switzerland">Switzerland</option>
          <option value="United Kingdom">United Kingdom</option>
          <option value="Ukraine">Ukraine</option>
          <option value="Vatican City">Vatican City</option>
        </optgroup>
        <optgroup label="Americas">
          <option value="Anguilla">Anguilla</option>
          <option value="Antigua and Barbuda">Antigua and Barbuda</option>
          <option value="Argentina">Argentina</option>
          <option value="Aruba">Aruba</option>
          <option value="Bahamas">Bahamas</option>
          <option value="Barbados">Barbados</option>
          <option value="Belize">Belize</option>
          <option value="Bermuda">Bermuda</option>
          <option value="Bolivia">Bolivia</option>
          <option value="Brazil">Brazil</option>
          <option value="British Virgin Islands">British Virgin Islands</option>
          <option value="Canada">Canada</option>
          <option value="Cayman Islands">Cayman Islands</option>
          <option value="Chile">Chile</option>
          <option value="Colombia">Colombia</option>
          <option value="Costa Rica">Costa Rica</option>
          <option value="Cuba">Cuba</option>
          <option value="Dominica">Dominica</option>
          <option value="Dominican Republic">Dominican Republic</option>
          <option value="Ecuador">Ecuador</option>
          <option value="El Salvador">El Salvador</option>
          <option value="Falkland Islands">Falkland Islands</option>
          <option value="French Guiana">French Guiana</option>
          <option value="Greenland">Greenland</option>
          <option value="Grenada">Grenada</option>
          <option value="Guadeloupe">Guadeloupe</option>
          <option value="Guatemala">Guatemala</option>
          <option value="Guyana">Guyana</option>
          <option value="Haiti">Haiti</option>
          <option value="Honduras">Honduras</option>
          <option value="Jamaica">Jamaica</option>
          <option value="Martinique">Martinique</option>
          <option value="Mexico">Mexico</option>
          <option value="Montserrat">Montserrat</option>
          <option value="Netherlands Antilles">Netherlands Antilles</option>
          <option value="Nicaragua">Nicaragua</option>
          <option value="Panama">Panama</option>
          <option value="Paraguay">Paraguay</option>
          <option value="Peru">Peru</option>
          <option value="Puerto Rico">Puerto Rico</option>
          <option value="Saint Barthélemy">Saint Barthélemy</option>
          <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
          <option value="Saint Lucia">Saint Lucia</option>
          <option value="Saint Martin">Saint Martin</option>
          <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
          <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
          <option value="Suriname">Suriname</option>
          <option value="Trinidad and Tobago">Trinidad and Tobago</option>
          <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
          <option value="United States">United States</option>
          <option value="Uruguay">Uruguay</option>
          <option value="Venezuela">Venezuela</option>
        </optgroup>
        <optgroup label="Asia">
          <option value="Afghanistan">Afghanistan</option>
          <option value="Armenia">Armenia</option>
          <option value="Azerbaijan">Azerbaijan</option>
          <option value="Bahrain">Bahrain</option>
          <option value="Bangladesh">Bangladesh</option>
          <option value="Bhutan">Bhutan</option>
          <option value="Brunei">Brunei</option>
          <option value="Cambodia">Cambodia</option>
          <option value="China">Chinese Mainland</option>
          <option value="Cyprus">Cyprus</option>
          <option value="Georgia">Georgia</option>
          <option value="Hong Kong">Hong Kong</option>
          <option value="India">India</option>
          <option value="Indonesia">Indonesia</option>
          <option value="Iran">Iran</option>
          <option value="Iraq">Iraq</option>
          <option value="Israel">Israel</option>
          <option value="Japan">Japan</option>
          <option value="Jordan">Jordan</option>
          <option value="Kazakhstan">Kazakhstan</option>
          <option value="Kuwait">Kuwait</option>
          <option value="Kyrgyzstan">Kyrgyzstan</option>
          <option value="Laos">Laos</option>
          <option value="Lebanon">Lebanon</option>
          <option value="Macau">Macau</option>
          <option value="Malaysia">Malaysia</option>
          <option value="Maldives">Maldives</option>
          <option value="Mongolia">Mongolia</option>
          <option value="Myanmar [Burma]">Myanmar [Burma]</option>
          <option value="Nepal">Nepal</option>
          <option value="Neutral Zone">Neutral Zone</option>
          <option value="North Korea">North Korea</option>
          <option value="Oman">Oman</option>
          <option value="Pakistan">Pakistan</option>
          <option value="People's Democratic Republic of Yemen">People's Democratic Republic of Yemen</option>
          <option value="Philippines">Philippines</option>
          <option value="Qatar">Qatar</option>
          <option value="Saudi Arabia">Saudi Arabia</option>
          <option value="Singapore">Singapore</option>
          <option value="South Korea">South Korea</option>
          <option value="Sri Lanka">Sri Lanka</option>
          <option value="Syria">Syria</option>
          <option value="Taiwan">Taiwan</option>
          <option value="Tajikistan">Tajikistan</option>
          <option value="Thailand">Thailand</option>
          <option value="Timor-Leste">Timor-Leste</option>
          <option value="Turkey">Turkey</option>
          <option value="Turkmenistan">Turkmenistan</option>
          <option value="United Arab Emirates">United Arab Emirates</option>
          <option value="Uzbekistan">Uzbekistan</option>
          <option value="Vietnam">Vietnam</option>
          <option value="Yemen">Yemen</option>
        </optgroup>
        <optgroup label="Oceania">
          <option value="American Samoa">American Samoa</option>
          <option value="Antarctica">Antarctica</option>
          <option value="Australia">Australia</option>
          <option value="Bouvet Island">Bouvet Island</option>
          <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
          <option value="Christmas Island">Christmas Island</option>
          <option value="Cocos [Keeling] Islands">Cocos [Keeling] Islands</option>
          <option value="Cook Islands">Cook Islands</option>
          <option value="Fiji">Fiji</option>
          <option value="French Polynesia">French Polynesia</option>
          <option value="French Southern Territories">French Southern Territories</option>
          <option value="Guam">Guam</option>
          <option value="Heard Island and McDonald Islands">Heard Island and McDonald Islands</option>
          <option value="Kiribati">Kiribati</option>
          <option value="Marshall Islands">Marshall Islands</option>
          <option value="Micronesia">Micronesia</option>
          <option value="Nauru">Nauru</option>
          <option value="New Caledonia">New Caledonia</option>
          <option value="New Zealand">New Zealand</option>
          <option value="Niue">Niue</option>
          <option value="Norfolk Island">Norfolk Island</option>
          <option value="Northern Mariana Islands">Northern Mariana Islands</option>
          <option value="Palau">Palau</option>
          <option value="Papua New Guinea">Papua New Guinea</option>
          <option value="Pitcairn Islands">Pitcairn Islands</option>
          <option value="Samoa">Samoa</option>
          <option value="Solomon Islands">Solomon Islands</option>
          <option value="South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
          <option value="Tokelau">Tokelau</option>
          <option value="Tonga">Tonga</option>
          <option value="Tuvalu">Tuvalu</option>
          <option value="Vanuatu">Vanuatu</option>
          <option value="Wallis and Futuna">Wallis and Futuna</option>
        </optgroup>
        <optgroup label="Africa">
          <option value="Algeria">Algeria</option>
          <option value="Angola">Angola</option>
          <option value="Benin">Benin</option>
          <option value="Botswana">Botswana</option>
          <option value="Burkina Faso">Burkina Faso</option>
          <option value="Burundi">Burundi</option>
          <option value="Cameroon">Cameroon</option>
          <option value="Cape Verde">Cape Verde</option>
          <option value="Central African Republic">Central African Republic</option>
          <option value="Chad">Chad</option>
          <option value="Comoros">Comoros</option>
          <option value="Congo - Brazzaville">Congo - Brazzaville</option>
          <option value="Congo - Kinshasa">Congo - Kinshasa</option>
          <option value="Côte d’Ivoire">Côte d’Ivoire</option>
          <option value="Djibouti">Djibouti</option>
          <option value="Egypt">Egypt</option>
          <option value="Equatorial Guinea">Equatorial Guinea</option>
          <option value="Eritrea">Eritrea</option>
          <option value="Ethiopia">Ethiopia</option>
          <option value="Gabon">Gabon</option>
          <option value="Gambia">Gambia</option>
          <option value="Ghana">Ghana</option>
          <option value="Guinea">Guinea</option>
          <option value="Guinea-Bissau">Guinea-Bissau</option>
          <option value="Kenya">Kenya</option>
          <option value="Lesotho">Lesotho</option>
          <option value="Liberia">Liberia</option>
          <option value="Libya">Libya</option>
          <option value="Madagascar">Madagascar</option>
          <option value="Malawi">Malawi</option>
          <option value="Mali">Mali</option>
          <option value="Mauritania">Mauritania</option>
          <option value="Mauritius">Mauritius</option>
          <option value="Mayotte">Mayotte</option>
          <option value="Morocco">Morocco</option>
          <option value="Mozambique">Mozambique</option>
          <option value="Namibia">Namibia</option>
          <option value="Niger">Niger</option>
          <option value="Nigeria">Nigeria</option>
          <option value="Rwanda">Rwanda</option>
          <option value="Réunion">Réunion</option>
          <option value="Saint Helena">Saint Helena</option>
          <option value="Senegal">Senegal</option>
          <option value="Seychelles">Seychelles</option>
          <option value="Sierra Leone">Sierra Leone</option>
          <option value="Somalia">Somalia</option>
          <option value="South Africa">South Africa</option>
          <option value="Sudan">Sudan</option>
          <option value="Swaziland">Swaziland</option>
          <option value="São Tomé and Príncipe">São Tomé and Príncipe</option>
          <option value="Tanzania">Tanzania</option>
          <option value="Togo">Togo</option>
          <option value="Tunisia">Tunisia</option>
          <option value="Uganda">Uganda</option>
          <option value="Western Sahara">Western Sahara</option>
          <option value="Zambia">Zambia</option>
          <option value="Zimbabwe">Zimbabwe</option>
        </optgroup>
      </select>
    </mat-form-field>
  </div>
  <div *ngIf="formGroup.value.country === 'United States'">
    <mat-form-field appearance="fill">
      <mat-label>{{ stateTitle() }}</mat-label>
      <select matNativeControl formControlName="state" [required]="forUser">
        <option value=""></option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District Of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="RI">Rhode Island</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
        <option value="AS">American Samoa</option>
        <option value="GU">Guam</option>
        <option value="MP">Northern Mariana Islands</option>
        <option value="PR">Puerto Rico</option>
        <option value="UM">United States Minor Outlying Islands</option>
        <option value="VI">Virgin Islands</option>
      </select>
    </mat-form-field>
  </div>
  <div *ngIf="formGroup.value.country === 'Canada'">
    <mat-form-field appearance="fill">
      <mat-label>{{ provinceTitle() }}</mat-label>
      <select matNativeControl formControlName="state" [required]="forUser">
        <option value=""></option>
        <option value="AB">Alberta</option>
        <option value="BC">British Columbia</option>
        <option value="MB">Manitoba</option>
        <option value="NB">New Brunswick</option>
        <option value="NL">Newfoundland and Labrador</option>
        <option value="NT">Northwest Territories</option>
        <option value="NS">Nova Scotia</option>
        <option value="NU">Nunavut</option>
        <option value="ON">Ontario</option>
        <option value="PE">Prince Edward Island</option>
        <option value="QC">Quebec</option>
        <option value="SK">Saskatchewan</option>
        <option value="YT">Yukon</option>
      </select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>{{ cityTitle() }}</mat-label>
      <input type="text" matInput formControlName="city" [required]="requireCity">
    </mat-form-field>
  </div>
</div>
